// extracted by mini-css-extract-plugin
export default {"tariffText":"TariffText-module__tariffText--g0zA3","error":"TariffText-module__error--_nt_r"};